"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store';
import router from '../router';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: '/adult'
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (store.state.user) {
      config.headers.Authorization = store.state.user.token;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    const vm = new Vue()

    // Do something with response error
    switch (error.response.status) {
      case 401:
        // router.push('/login');
      case 422:
        vm.$bvToast.toast(error.response.data.message, {
          title: '错误提示',
          variant: 'danger',
        });
        break;
      case 400:
        vm.$bvToast.toast(error.response.data.message, {
          title: '错误提示',
          variant: 'danger',
        });
        break;
      case 500:
        vm.$bvToast.toast('服务器错误，请稍后再试', {
          title: '错误提示',
          variant: 'danger',
        });
    }
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
